module.exports = __webpack_public_path__ + "fonts/payback_script.a968e923.woff";